import { lazyWithRetry } from "utils/lazy-with-retry";

const Dashboard = lazyWithRetry(() => import("./Dashboard"));

export default Dashboard;
